<template>
  <v-card flat tile class="transparent">
    <v-card-title class="body-2 py-2 px-0">
      A VIVÊNCIA INICIA EM
    </v-card-title>
    <v-card-text class="d-flex px-0">
      <div class="d-inline-block text-center justify-end">
        <v-btn small class="primary display-1 px-0 mx-0" height="50">
          <span class="barlow font-weight-bold">{{days}}</span>
        </v-btn>
        <div class="caption d-block">
          <span class="barlow font-weight-medium">dias</span>
        </div>
      </div>

      <div class="px-1 headline" style="heigh: 50px; line-height: 50px">
        <span class="oswald font-weight-black">:</span>
      </div>

      <div class="text-center">
        <v-btn small class="primary display-1 px-0 mx-0" height="50">
          <span class="barlow font-weight-bold">{{hours}}</span>
        </v-btn>
        <div class="caption d-block">
          <span class="barlow font-weight-medium">horas</span>
        </div>
      </div>

      <div class="px-1 headline" style="heigh: 50px; line-height: 50px">
        <span class="oswald font-weight-black">:</span>
      </div>

      <div class="text-center">
        <v-btn small class="primary display-1 px-0 mx-0" height="50">
          <span class="barlow font-weight-bold">{{minutes}}</span>
        </v-btn>
        <div class="caption d-block">
          <span class="barlow font-weight-medium">minutos</span>
        </div>
      </div>

      <div class="px-1 headline" style="heigh: 50px; line-height: 50px">
        <span class="oswald font-weight-black">:</span>
      </div>

      <div class="text-center">
        <v-btn small class="primary display-1 px-0 mx-0" height="50">
          <span class="barlow font-weight-bold">{{seconds}}</span>
        </v-btn>
        <div class="caption d-block">
          <span class="barlow font-weight-medium">segundos</span>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['endtime'],
  data: () => ({
    starttime: '',
    //endtime: 'Sep 8, 2020 16:37:25',
    start: '',
    end: '',
    interval: '',
    days: '',
    minutes: '',
    hours: '',
    seconds: ''
  }),
  methods: {
    getImg(i) {
      return require('../assets/img/'+i)
    },
    timerCount (start,end) {
      var now = new Date().getTime()
      //var distance = start - now
      var passTime = end - now
      
      if(passTime < 0) {
        clearInterval(this.interval)
        this.days = 0
        this.hours = 0
        this.minutes = 0
        this.seconds = 0
      }
      else {
        this.calcTime(passTime)
      }

      //console.log('DISTANCE',distance)
      //console.log('PASSTIME',passTime)
    },
    calcTime: function(dist){
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24))
      this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60))
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000)
    }
  },
  mounted () {
    this.start = new Date(this.starttime).getTime()
    this.end = new Date(this.endtime).getTime()
    this.timerCount(this.start, this.end)

    // LOOP
    this.interval = setInterval(() => {
      this.timerCount(this.start,this.end);
    }, 1000);
  }
}
</script>